module.exports = __webpack_public_path__ + "static/media/iconEdit2.7e95b670.svg";